$(document).ready(function () {
  $('body').on('change', '.custom-file-input', function() {
    if ($(this)[0].files[0] !== undefined) {
      var targetLabel = $(this).parents('.custom-file').find('label');

      targetLabel.find('span').html($(this)[0].files[0].name);
      targetLabel.addClass('btn-primary');
      targetLabel.removeClass('btn-file');
      targetLabel.find('.upload-icon').addClass('d-none');
      targetLabel.find('.re-upload-icon').removeClass('d-none');
    }
  });

  $('body').on('change', '.file-input', function () {
    if ($(this)[0].files[0] !== undefined) {
      $(this).parent().find('.label-wording').html($(this)[0].files[0].name);
    }
  });
});
